import { defineAction } from '~/prix'
import alertCreateAction from './alertCreate.action.json' with { type: 'json' }
import { alertObject } from '../alertObject'
import { z } from 'zod'

const alertCreateDefinition = defineAction({
  ...alertCreateAction,

  input: alertObject.pick({
    id: true,
    residenceId: true,
    plusCode: true,
    title: true,
    observation: true,
    latitude: true,
    longitude: true,
    accuracy: true,
    radiusMeters: true,
    communityId: true,
    buildingId: true,
    fullAddress: true,
    classification: true,
    createdAt: true,
    updatedAt: true,
    synchronizedAt: true,
    validUntil: true,
  }),
  output: z.object({}),
})

export default alertCreateDefinition
